import ProductsSliderPresenter from "../../products-slider/presenter/products-slider.js";
import LinksListPresenter from "../../links-list/presenter/links-list.js";

import RelatedLinksListView from "../view/related-links-list.js";
import ResultsWrapperView from "../view/results-wrapper.js";
import RelatedLink from "../view/link.js";

import ProductsRelatedModel from "../model/products-related.js";

import {
  sendXhr
} from "../../../utils/send-xhr/send-xhr.js";

import {
  createElement,
  replace
} from "../../render/render.js";

import {
  defaultProductsRelatedModelData,
  ActionType,
  RequestAction,
  CONNECTOR_URL,
  RESET_PARENT_HEIGHT_TIMEOUT_TIME
} from "../const.js";
export default class ProductsRelated {
  constructor(productsListWrapper, categoryLinksList) {
    this._productsListWrapper = productsListWrapper;
    this._categoryLinksList = categoryLinksList;

    this._connectorUrl = CONNECTOR_URL;

    this._productsSliderPresenter = null;
    this._linksListPresenter = null;

    this._resultsWrapperView = null;
    this._relatedLinksListView = null;
    this._relatedLinksViews = [];

    this._model = null;

    this._handleRelatedLinkClick = this._handleRelatedLinkClick.bind(this);
    this._handleChangeData = this._handleChangeData.bind(this);
  }

  init() {
    this._productsSliderPresenter = new ProductsSliderPresenter(this._productsListWrapper);
    this._productsSliderPresenter.init();

    this._linksListPresenter = new LinksListPresenter(this._categoryLinksList);
    this._linksListPresenter.init();

    this._resultsWrapperView = new ResultsWrapperView(this._productsListWrapper);
    this._relatedLinksListView = new RelatedLinksListView(this._categoryLinksList);

    Array.from(this._relatedLinksListView.getLinks())
      .forEach((item, index) => {
        const view = new RelatedLink(item, index);
        view.setClickHandler(this._handleRelatedLinkClick);
        this._relatedLinksViews.push(view);
      });

    this._model = new ProductsRelatedModel(Object.assign(
        {},
        defaultProductsRelatedModelData
    ));

    this._model.addObserver(this._handleChangeData);
  }

  _listChangeCallback(layout) {
    this._resultsWrapperView.setParentHeight();

    const oldResultsWrapper = this._resultsWrapperView.getElement();
    const newResultsWrapper = createElement(layout);

    replace(newResultsWrapper, oldResultsWrapper);

    this._resultsWrapperView = new ResultsWrapperView(newResultsWrapper);
    this._productsListWrapper = newResultsWrapper;

    this._productsSliderPresenter.destroy();
    this._productsSliderPresenter = new ProductsSliderPresenter(this._productsListWrapper);
    this._productsSliderPresenter.init();

    setTimeout(() => {
      this._resultsWrapperView.resetParent();
    }, RESET_PARENT_HEIGHT_TIMEOUT_TIME);
  }

  _processListChange() {
    const activeLinkIndex = this._model.getData().activeLinkIndex;
    const linkId = this._relatedLinksViews[activeLinkIndex].getId();
    const relatedIds = this._linksListPresenter.getRelatedIds();

    this._relatedLinksViews.forEach((view, index) => {
      if (index === activeLinkIndex) {
        view.activate();
      } else {
        view.reset();
      }
    });

    const requestArgs = {
      body: [
        `action=${RequestAction.GET_RELATED}`,
        `category_id=${linkId}`,
        `related_ids=${relatedIds}`
      ],
      connectorUrl: this._connectorUrl,
      loadstartCallback: () => {
        this._model.changeData(Object.assign(
            {},
            this._model.getData(),
            {
              isLoading: true
            }
        ));
      },
      loadCallback: (response) => {
        const data = JSON.parse(response);

        if (!data.success) {
          console.error(data.error);
          return;
        }

        this._listChangeCallback(data.markup);
      },
      loadendCallback: () => {
        this._model.changeData(Object.assign(
            {},
            this._model.getData(),
            {
              isLoading: false
            }
        ));
      },
    };
    sendXhr(requestArgs);
  }

  _handleRelatedLinkClick(evt, index) {
    evt.preventDefault();

    const modelData = this._model.getData();

    if (index === modelData.activeLinkIndex || modelData.isLoading) {
      return;
    }

    this._model.changeData(Object.assign(
        {},
        modelData,
        {
          activeLinkIndex: index
        }
    ), ActionType.CHANGE_LIST);
  }

  _handleChangeData(action) {
    switch (action) {
      case ActionType.CHANGE_LIST:
        this._processListChange();
        break;
    }
  }
}
